import axios from 'lib/axios'

// Utility function to flatten department-grouped staff data
export const flattenStaffData = (staffData) => {
  // Handle the actual API response structure: { success: true, message: "Staff List", data: { staff: {...} } }
  if (!staffData?.data?.staff) return []
  
  // staff is an object with department names as keys, each containing an array of staff members
  const staffObject = staffData.data.staff
  
  // Flatten all department arrays into a single array
  const allStaff = Object.values(staffObject).flat()
  
  
  
  return allStaff
}

// HR API service for user management
export const hrApiService = {
  // Get all users from current user's tenant (main staff directory)
  getUsers: async () => {
    return axios.get('/staff-list').then(response => response.data)
  },

  // Get basic staff directory for chat purposes (no permission required)
  getBasicStaffDirectory: async () => {
    return axios.get('/staff-directory').then(response => response.data)
  },

  // Get simple staff list with pagination and search
  getSimpleStaffList: async (params = {}) => {
    const queryParams = new URLSearchParams()
    if (params.per_page) queryParams.append('per_page', params.per_page)
    if (params.search) queryParams.append('search', params.search)
    
    const url = `/staff-list-simple${queryParams.toString() ? '?' + queryParams.toString() : ''}`
    return axios.get(url).then(response => response.data)
  },

  // Get users by specific tenant ID (admin endpoint)
  getUsersByTenant: async (tenantId) => {
    return axios.get(`/admin/staff`).then(response => response.data)
  },

  // Get current user profile
  getMyAccount: async () => {
    return axios.get('/my-account').then(response => response.data)
  },

  // Get user details by ID (staff details)
  getUserById: async (userId) => {
    return axios.get(`/staff/${userId}`).then(response => response.data)
  },

  // Search users (using simple staff list with search)
  searchUsers: async (query) => {
    return axios.get(`/staff-list-simple?search=${encodeURIComponent(query)}`).then(response => response.data)
  },

  // Get active staff list for shift management
  getActiveStaff: async () => {
    return axios.get('/active-staff-list').then(response => response.data)
  }
}

export default hrApiService
